import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';

const useGtmHook = () => {
  const appSettingsStore = useAppSettingsStore();
  const authStore = useAuthStore();

  const loadOldNoScript = () => {
    const gtmKey = appSettingsStore.gtmKey;

    if (!gtmKey) { return; }

    const oldNoScript = document.querySelector('#gtmNoScript');
    if (!oldNoScript) {
      const noscript = document.createElement('noscript');
      noscript.setAttribute('id', 'gtmNoScript');
      noscript.innerHTML = `<iframe height="0" width="0" style="display:none;visibility:hidden" src="https://www.googletagmanager.com/ns.html?id=${ gtmKey }"></iframe>`;
      document.body.insertBefore(noscript, document.body.childNodes[0]);
    }
  };

  const loadGoogleAnalyticsScript = () => {
    const gtmKey = appSettingsStore.gtmKey;
    const userMsisdn = authStore.user.msisdn;

    if (!gtmKey) { return; }

    if (!document.querySelector('#gtagjsScript')) {
      const gtagjsScript = document.createElement('script');
      gtagjsScript.setAttribute('id', 'gtagjsScript');
      gtagjsScript.async = true;
      gtagjsScript.src = `https://www.googletagmanager.com/gtag/js?id=${ gtmKey }`;
      document.head.appendChild(gtagjsScript);
    }

    const getGtagScriptConfigCode = `gtag('config', '${ gtmKey }'${ userMsisdn ? `, {user_id: '${ userMsisdn }'}` : '' });`;
    const getGaConfigScript = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      ${ getGtagScriptConfigCode }
      `;

    let gaConfigScript = document.querySelector('#gaConfigScript');
    if (gaConfigScript) {
      gaConfigScript.remove();
    }

    gaConfigScript = document.createElement('script');
    gaConfigScript.setAttribute('id', 'gaConfigScript');
    gaConfigScript.innerHTML = getGaConfigScript;
    document.head.appendChild(gaConfigScript);
  };

  return {
    loadOldNoScript,
    loadGoogleAnalyticsScript,
  };
};

export default useGtmHook;
